var map = {
	"./DIv0000.png": 1277,
	"./DIv0001.png": 1278,
	"./DIv0002.png": 1279,
	"./DIv0003.png": 1280,
	"./DIv0004.png": 1281,
	"./DIv0005.png": 1282,
	"./DIv0006.png": 1283,
	"./DIv0007.png": 1284,
	"./DarkBlue0000.png": 1285,
	"./DarkBlue0001.png": 1286,
	"./DarkBlue0002.png": 1287,
	"./DarkBlue0003.png": 1288,
	"./DarkBlue0004.png": 1289,
	"./DarkBlue0005.png": 1290,
	"./DarkBlue0006.png": 1291,
	"./DarkBlue0007.png": 1292,
	"./Green0000.png": 1293,
	"./Green0001.png": 1294,
	"./Green0002.png": 1295,
	"./Green0003.png": 1296,
	"./Green0004.png": 1297,
	"./Green0005.png": 1298,
	"./Green0006.png": 1299,
	"./Green0007.png": 1300,
	"./LightBlue0000.png": 1301,
	"./LightBlue0001.png": 1302,
	"./LightBlue0002.png": 1303,
	"./LightBlue0003.png": 1304,
	"./LightBlue0004.png": 1305,
	"./LightBlue0005.png": 1306,
	"./LightBlue0006.png": 1307,
	"./LightBlue0007.png": 1308,
	"./Red0000.png": 1309,
	"./Red0001.png": 1310,
	"./Red0002.png": 1311,
	"./Red0003.png": 1312,
	"./Red0004.png": 1313,
	"./Red0005.png": 1314,
	"./Red0006.png": 1315,
	"./Red0007.png": 1316,
	"./White0000.png": 1317,
	"./White0001.png": 1318,
	"./White0002.png": 1319,
	"./White0003.png": 1320,
	"./White0004.png": 1321,
	"./White0005.png": 1322,
	"./White0006.png": 1323,
	"./White0007.png": 1324,
	"./Yellow0000.png": 1325,
	"./Yellow0001.png": 1326,
	"./Yellow0002.png": 1327,
	"./Yellow0003.png": 1328,
	"./Yellow0004.png": 1329,
	"./Yellow0005.png": 1330,
	"./Yellow0006.png": 1331,
	"./Yellow0007.png": 1332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1276;